var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "25",
    cy: "25",
    r: "25"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.33 27.94c-.32.48-.68.97-1.07 1.5 3.26.43 4.93 1.37 4.93 1.84 0 .62-2.96 2.08-8.69 2.08-5.73 0-8.69-1.46-8.69-2.08 0-.47 1.67-1.41 4.93-1.85-.39-.52-.74-1.01-1.07-1.49-3.22.55-5.67 1.67-5.67 3.34C15 33.72 20.28 35 25.5 35S36 33.72 36 31.28c0-1.67-2.45-2.79-5.67-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 15c-3.22 0-5.83 2.78-5.83 6.22 0 2.46 3 7.17 4.7 9.64.26.38.68.61 1.13.61.45 0 .87-.23 1.13-.61 1.7-2.47 4.7-7.18 4.7-9.64 0-3.44-2.6-6.22-5.83-6.22zm.03 9.41a3.42 3.42 0 0 1-3.48-3.35 3.42 3.42 0 0 1 3.48-3.34c1.91 0 3.47 1.5 3.47 3.34a3.42 3.42 0 0 1-3.47 3.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 19.7c-.64 0-1.17.53-1.17 1.18 0 .65.53 1.18 1.17 1.18.64 0 1.17-.53 1.17-1.18 0-.65-.53-1.17-1.17-1.17z"
  }))));
});